import {
    allFetch
} from "../Domain";

/**
 * @description ECC
 */
export const Company = (() => {
    /**
     * @description  公司新建
     * @param {string} name 公司名稱
     * @param {string} tax_id 統編號碼
     * @param {string} city 城市
     * @param {string} area 地區
     * @param {string} address 地址
     * @param {string} phone 電話
     * @param {string} url 網址
     * @param {string} note 備註
     * @param {string} transfer_account 匯款帳號
     * @param {string} start_date 起始年月
     * @param {string} howmany_month 每幾個月
     * @param {string} which_date 幾號通知
     * @param {string} howmany_beforeday 幾天前通知
     * @returns 
     */
    const CompanyCreate = async (obj) => {
        return await allFetch('Company/CompanyCreate', obj);
    }

    /**
     * @description  公司細項
     * @param {string} type 類別
     * @param {string} name 公司名稱
     * @param {string} city 城市
     * @param {string} area 地區
     * @param {string} visible 是否可見
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     * @returns 
     */
    const CompanySearch = async (obj) => {
        return await allFetch('Company/CompanySearch', obj);
    }

    /**
     * @description  公司修改
     * @param {string} company_id 公司流水號
     * @param {string} name 公司名稱
     * @param {string} tax_id 統編號碼
     * @param {string} city 城市
     * @param {string} area 地區
     * @param {string} address 地址
     * @param {string} phone 電話
     * @param {string} url 網址
     * @param {string} note 備註
     * @param {string} visible 是否可見
     * @param {string} transfer_account 匯款帳號
     * @param {string} start_date 起始年月
     * @param {string} howmany_month 每幾個月
     * @param {string} which_date 幾號通知
     * @param {string} howmany_beforeday 幾天前通知
     * @returns 
     */
    const CompanyUpdate = async (obj) => {
        return await allFetch('Company/CompanyUpdate', obj);
    }

    /**
     * @description  公司查詢
     * @param {string} company_id 公司流水號
     * @returns 
     */
    const CompanyDetail = async (obj) => {
        return await allFetch('Company/CompanyDetail', obj);
    }

    /**
     * @description  聯絡人新建
     * @param {string} company_id 公司流水號
     * @param {string} name 聯絡人姓名
     * @param {string} phone 聯絡人電話
     * @param {string} gender 聯絡人性別
     * @param {string} position 聯絡人職稱
     * @param {string} email 聯絡人信箱
     * @returns 
     */
    const CompanyContacterCreate = async (obj) => {
        return await allFetch('Company/CompanyContacterCreate', obj);
    }

    /**
     * @description  聯絡人查詢
     * @param {string} company_id 公司流水號
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     * @returns 
     */
    const CompanyContacterSearch = async (obj) => {
        return await allFetch('Company/CompanyContacterSearch', obj);
    }

    /**
     * @description  聯絡人修改
     * @param {string} cc_id 公司聯絡人流水號
     * @param {string} company_id 公司流水號
     * @param {string} name 聯絡人姓名
     * @param {string} phone 聯絡人電話
     * @param {string} gender 聯絡人性別
     * @param {string} position 聯絡人職稱
     * @param {string} email 聯絡人信箱
     * @returns 
     */
    const CompanyContacterUpdate = async (obj) => {
        return await allFetch('Company/CompanyContacterUpdate', obj);
    }

    /**
     * @description  聯絡人刪除
     * @param {string} cc_id 公司聯絡人流水號
     * @returns 
     */
    const CompanyContacterDelete = async (obj) => {
        return await allFetch('Company/CompanyContacterDelete', obj);
    }

    /**
     * @description  聯絡人查詢
     * @param {string} cc_id 公司聯絡人流水號
     * @returns 
     */
    const CompanyContacterDetail = async (obj) => {
        return await allFetch('Company/CompanyContacterDetail', obj);
    }

    return {
        CompanyCreate,
        CompanySearch,
        CompanyUpdate,
        CompanyDetail,
        CompanyContacterCreate,
        CompanyContacterSearch,
        CompanyContacterUpdate,
        CompanyContacterDelete,
        CompanyContacterDetail
    }
})();